@if (tagGroup) {
    <mat-card appearance="outlined" class="legend">
        <div class="header">
            <div class="title">
                <span class="group-name">{{tagGroup.name}}</span>
                <span class="subtitle">Tag group{{linqset ? ' · actions in this model' : ''}}</span>
            </div>
            <button mat-icon-button matTooltip="Close tag group" aria-label="Close the tag group" (click)="closeTagGroup()"><mat-icon>close</mat-icon></button>
        </div>
        @if (tagGroup.tags?.length) {
            <ul class="tags">
                @for (tag of tagGroup.tags; track tag._key) {
                    <li [matTooltip]="tag.description" [matTooltipDisabled]="!tag.description">
                        <i class="fa fa-solid fa-tag" [style]="getColourStyleForTag(tag)" aria-hidden="true"></i>
                        <span class="tag-name">{{tag.name}}</span>
                        @if (linqset) {
                            <span class="count">{{counts[tag._key] || 0}}</span>
                        }
                    </li>
                }
                @if (linqset && untagged) {
                    <li class="untagged">
                        <i class="fa fa-solid fa-tag" aria-hidden="true"></i>
                        <span class="tag-name">No tag</span>
                        <span class="count">{{untagged}}</span>
                    </li>
                }
            </ul>
        }@else {
            <p class="note">This tag group has no tags yet.</p>
        }
        @if (hasWriteAccess) {
            <button mat-button color="accent" class="edit" (click)="editTagGroup()"><mat-icon>edit</mat-icon>Edit tag group</button>
        }
    </mat-card>
}
